<template>
  <div :class="['box', boxClass, collapsed ? 'collapsed-box' : '']">
    <div v-if="$slots['header']" class="box-header">
      <slot name="header"></slot>
      <el-button 
        v-if="collapsed"
        size="small" 
        plain 
        :title="hidden ? '显示' :'隐藏' "
        :icon="hidden ? 'icon icon-plus' : 'icon icon-minus'" 
        class="fold-button"
        @click="toggleCollapse()"></el-button>
    </div>
    <el-collapse-transition>
      <div class="box-body" v-show="!hidden">
        <slot></slot>
      </div>
    </el-collapse-transition>    
  </div>
</template>

<script>
export default {
  data () {
    return {
      hidden: false
    }
  },
  props: {
    boxClass: {
      type: String,
      default: 'box-container'
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleCollapse () {
      this.hidden = !this.hidden
    }
  }
}
</script>

<style>
.box-body-fade-enter-active, .box-body-fade-leave-active {
  transition: opacity .5s;
}
.box-body-fade-enter, .box-body-fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/box-container.vue